import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories, siteName, siteTagline } from "@/mocks/site";

const categoryLinks = categories.map((item) => ({
  label: item.name,
  to: `/?cat=${item.slug}#latest`,
}));

const staticLinks = [
  { label: "首页", to: "/" },
  { label: "深扒专题", to: "/#deepdive" },
  { label: "爆料热榜", to: "/#ranking" },
  { label: "常见问题", to: "/#faq" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="hidden border-b border-background-200/70 bg-foreground-950 md:block">
        <div className="mx-auto flex max-w-content items-center justify-between px-4 md:px-6 py-2 text-xs text-background-100">
          <p className="flex items-center gap-2">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-flashlight-fill text-accent-400"></i>
            </span>
            <span>{siteTagline} · 把事件的脉络和证据链讲清楚</span>
          </p>
          <div className="flex items-center gap-5">
            <span className="text-background-300">2026 年 9 月 10 日 · 周四</span>
            <Link
              to="/#subscribe"
              className="cursor-pointer text-accent-400 transition-colors hover:text-accent-300"
            >
              订阅每周深扒
            </Link>
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-content items-center justify-between gap-4 px-4 md:px-6 py-3">
        <Link to="/" className="flex cursor-pointer items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              {siteName}
            </span>
            <span className="mt-1 hidden text-[11px] tracking-widest text-foreground-500 sm:block">
              深扒 · 内幕 · 起底
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {staticLinks.slice(0, 1).map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </Link>
          ))}
          {categoryLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </Link>
          ))}
          {staticLinks.slice(1).map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/#subscribe"
            className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <i className="ri-mail-send-line"></i>
            线索投稿
          </Link>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((prev) => !prev)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-content flex-col px-4 py-3" aria-label="移动端导航">
            {[...staticLinks, ...categoryLinks].map((item) => (
              <Link
                key={`m-${item.to}-${item.label}`}
                to={item.to}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}